import PayLaterPopUp from './PayLaterPopUp';

export default PayLaterPopUp;
